import { ReactNode } from "react";
import { Stack } from "@mui/material";

export const RowWrapper = ({
  children,
  isHighlighted,
}: {
  children: ReactNode;
  isHighlighted?: boolean;
}) => {
  return (
    <Stack
      sx={{
        backgroundColor: isHighlighted ? "rgb(244, 245, 249)" : "transparent",
        borderBottom: "1px solid #E0E0E0",
        padding: "14px 0",
        flexWrap: "nowrap",
        flexDirection: "row",
      }}
    >
      {children}
    </Stack>
  );
};
